import { sidebarData, storeSidebarData } from "util/data/sidebar";

/**
 * Flatten nested sidebar routes into searchable leaf pages.
 */
export function flattenMenuItems(items, messages = {}, parentLabel = null) {
  const out = [];
  (items || []).forEach(item => {
    const key = item.name || item.listname;
    const label =
      (messages && key && messages[key]) ||
      (key ? String(key).replace(/^sidebar\./, "") : "Page");
    const group = parentLabel || "Menu";

    if (item.routepath) {
      out.push({
        type: "menu",
        id: `menu:${item.routepath}`,
        label,
        path: item.routepath,
        icon: item.iconClass || "fas fa-file",
        group,
        adminOnly: !!item.adminOnly
      });
    }

    if (item.child && item.child.length) {
      out.push(...flattenMenuItems(item.child, messages, label));
    }
  });
  return out;
}

export function getMenuCatalog({ isStore, adminType, messages }) {
  const root = isStore ? storeSidebarData : sidebarData;
  let items = flattenMenuItems(root, messages);

  if (adminType === "STORE") {
    items = items.filter(i => i.path !== "/dashboard");
  }
  if (adminType !== "MASTER") {
    items = items.filter(i => !i.adminOnly);
  }

  // De-dupe by path
  const seen = new Set();
  return items.filter(i => {
    if (seen.has(i.path)) return false;
    seen.add(i.path);
    return true;
  });
}

export function filterMenuCatalog(catalog, query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return [];
  return catalog
    .filter(item => {
      const hay = `${item.label} ${item.path} ${item.group}`.toLowerCase();
      return hay.includes(q);
    })
    .slice(0, 8);
}
